import React from 'react';
import clsx from 'clsx';
import { Icon } from '@/components/ui';

/** Fixed, touch-friendly palette for the account color indicator. */
export const SWATCHES = [
  '#4F46E5',
  '#2563EB',
  '#0EA5E9',
  '#14B8A6',
  '#22C55E',
  '#84CC16',
  '#EAB308',
  '#F59E0B',
  '#F97316',
  '#EF4444',
  '#EC4899',
  '#8B5CF6',
];

interface ColorSwatchGridProps {
  value: string | null;
  onSelect: (hex: string) => void;
}

export const ColorSwatchGrid = ({ value, onSelect }: ColorSwatchGridProps) => (
  <div className="tw-grid tw-grid-cols-6 tw-gap-[10px]">
    {SWATCHES.map((hex) => {
      const selected = value?.toUpperCase() === hex.toUpperCase();
      return (
        <button
          key={hex}
          type="button"
          aria-label={hex}
          aria-pressed={selected}
          onClick={() => onSelect(hex)}
          className={clsx(
            'tw-w-full tw-aspect-square tw-rounded-full tw-cursor-pointer tw-border-2 tw-flex tw-items-center tw-justify-center tw-p-0',
            selected ? 'tw-border-ds-ink' : 'tw-border-transparent'
          )}
          style={{ backgroundColor: hex }}
        >
          {selected && <Icon name="check" size={16} color="#fff" />}
        </button>
      );
    })}
  </div>
);
